import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import FormDrawer from "src/components/Form/FormDrawer";
import { updateAgreementSaga } from "src/store/agreements/saga";
import { AgreementDetailDto } from "src/store/agreements/type";
import * as Yup from "yup";
import { dripiconlist } from "src/helpers/iconList";
import { getAgreementTypes } from "src/store/system/saga";
import { AgreementTypeDto } from "src/store/system/type";
const AgreementsEditForm = ({
  data,
  onHide,
  open,
  onSuccessClick,
}: {
  data: AgreementDetailDto;
  onSuccessClick: (message: string) => void;
  onHide: () => void;
  open: boolean;
}) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [types, setTypes] = useState<AgreementTypeDto[]>([]);
  useEffect(() => {
    open &&
      dispatch(
        getAgreementTypes({
          payload: {
            onSuccess: (m, p) => setTypes(p),
            onError: () => {},
          },
        })
      );
  }, [dispatch, open]);
  return (
    <React.Fragment>
      <FormDrawer
        drawerProps={{
          isOpen: open,
          onHide: onHide,
          title: t("Agreements.EditFormTitle").toString(),
        }}
        onHide={onHide}
        loader
        initialValues={{
          Id: data.Id,
          Description: data.Description,
          Title: data.Title,
          IsActive: data.IsActive,
          PolicyTypeId: data.PolicyTypeId,
          Translates: data.Translates.map((x) => {
            return {
              LanguageId: x.LanguageId,
              Title: x.Title,
              Description: x.Description,
            };
          }),
        }}
        validationSchema={Yup.object().shape({
          Title: Yup.string().required(t("Validation.Required").toString()),
          Description: Yup.string().required(
            t("Validation.Required").toString()
          ),
        })}
        onSubmit={(values) => {
          dispatch(
            updateAgreementSaga({
              payload: {
                onSuccess: (message, payload) => {
                  onHide();
                  onSuccessClick(message);
                },
                onError: (message) => {
                  toast.error(message, {
                    theme: "colored",
                  });
                },
              },
              id: data.Id,
              body: values,
            })
          );
        }}
        multilanguageinputs={[
          {
            field: "Title",
            label: t("Agreements.Title").toString(),
          },
          {
            field: "Description",
            label: t("Agreements.Description").toString(),
            isEditor: true,
          },
        ]}
        inputs={[
          {
            field: "PolicyTypeId",
            label: t("Agreements.Type").toString(),
            type: "select",
            lookup: {
              labelKey: "Name",
              valueKey: "EnumId",
              options: types,
            },
          },

          {
            field: "IsActive",
            label: t("Agreements.IsActive").toString(),
            type: "switch",
          },
        ]}
      />
    </React.Fragment>
  );
};
export default AgreementsEditForm;
